import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'

Vue.use(VueRouter)

// 新角色体系（MySQL新库）:
// SYSTEM_ADMIN 系统管理员：全部
// DEVICE_OPERATOR 设备运维人员：实时态势/设备/历史/预警
// DATA_ANALYST 数据分析人员：实时态势/历史/预警/报表
// BUSINESS_MANAGER 业务管理人员：实时态势/设备/历史/预警/报表/系统
// BUSINESS_VIEWER 业务查看人员：实时态势/历史/预警/报表
// EXTERNAL_SYSTEM 外部系统：仅API（无前端页面）

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: { title: '登录', public: true }
  },
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: { title: '实时态势', roles: ['ROLE_ADMIN', 'ROLE_MONITOR', 'ROLE_AUDITOR', 'ROLE_REPORT', 'ROLE_VIEWER', 'SYSTEM_ADMIN', 'DEVICE_OPERATOR', 'DATA_ANALYST', 'BUSINESS_VIEWER', 'BUSINESS_MANAGER'] }
  },
  {
    path: '/devices',
    name: 'devices',
    component: () => import('../views/Devices.vue'),
    meta: { title: '设备与站点', roles: ['ROLE_ADMIN', 'ROLE_MONITOR', 'SYSTEM_ADMIN', 'DEVICE_OPERATOR', 'BUSINESS_MANAGER'] }
  },
  {
    path: '/observations',
    name: 'observations',
    component: () => import('../views/Observations.vue'),
    meta: { title: '历史数据', roles: ['ROLE_ADMIN', 'ROLE_MONITOR', 'ROLE_AUDITOR', 'ROLE_REPORT', 'ROLE_VIEWER', 'SYSTEM_ADMIN', 'DEVICE_OPERATOR', 'DATA_ANALYST', 'BUSINESS_VIEWER', 'BUSINESS_MANAGER'] }
  },
  {
    path: '/alerts',
    name: 'alerts',
    component: () => import('../views/Alerts.vue'),
    meta: { title: '预警中心', roles: ['ROLE_ADMIN', 'ROLE_MONITOR', 'ROLE_AUDITOR', 'SYSTEM_ADMIN', 'DEVICE_OPERATOR', 'DATA_ANALYST', 'BUSINESS_VIEWER', 'BUSINESS_MANAGER'] }
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('../views/Reports.vue'),
    meta: { title: '报表中心', roles: ['ROLE_ADMIN', 'ROLE_AUDITOR', 'ROLE_REPORT', 'SYSTEM_ADMIN', 'DATA_ANALYST', 'BUSINESS_VIEWER', 'BUSINESS_MANAGER'] }
  },
  {
    path: '/system',
    name: 'system',
    component: () => import('../views/System.vue'),
    meta: { title: '系统管理', roles: ['ROLE_ADMIN', 'SYSTEM_ADMIN', 'BUSINESS_MANAGER'] }
  },
  {
    path: '/recycle',
    name: 'recycle',
    component: () => import('../views/RecycleBin.vue'),
    meta: { title: '回收站', roles: ['ROLE_ADMIN', 'SYSTEM_ADMIN', 'DEVICE_OPERATOR', 'DATA_ANALYST', 'BUSINESS_MANAGER'] }
  },
  {
    path: '/pollen-detail',
    name: 'pollenDetail',
    component: () => import('../views/PollenDetail.vue'),
    meta: { title: '花粉详情', roles: ['ROLE_ADMIN', 'SYSTEM_ADMIN', 'DEVICE_OPERATOR', 'DATA_ANALYST', 'BUSINESS_VIEWER', 'BUSINESS_MANAGER', 'ROLE_MONITOR', 'ROLE_AUDITOR', 'ROLE_REPORT', 'ROLE_VIEWER'] }
  }
]

const router = new VueRouter({
  routes
})

function getLocalUser() {
  try {
    return JSON.parse(sessionStorage.getItem('pollen_user') || 'null')
  } catch (e) {
    return null
  }
}

// 全局前置守卫：未登录跳登录页；无权限提示并跳首页
router.beforeEach((to, from, next) => {
  const user = getLocalUser()
  const logged = !!sessionStorage.getItem('pollen_token') && !!user

  if (to.meta && to.meta.public) {
    // 已登录访问登录页 → 直接进首页
    if (logged && to.path === '/login') return next('/')
    return next()
  }
  if (!logged) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }
  const roles = to.meta && to.meta.roles
  if (roles && roles.length && user.roleCode && !roles.includes(user.roleCode)) {
    Vue.prototype.$message && Vue.prototype.$message.warning('当前账号无权限访问该页面')
    return next('/')
  }
  next()
})

router.afterEach(to => {
  document.title = (to.meta && to.meta.title ? to.meta.title + ' | ' : '') + '花粉监测数据管理平台'
})

export default router
